import Vue from 'vue';
import Router from 'vue-router';
import About from './views/About.vue';
import Galleries from './views/Galleries.vue';
import Gallery from './views/Gallery.vue';
import Home from './views/Home.vue';
import Portfolio from './views/Portfolio.vue';
import Error404 from './views/404.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/about',
      name: 'about',
      component: About,
    },
    {
      path: '/galleries',
      name: 'galleries',
      component: Galleries,
    },
    {
      path: '/galleries/:id',
      component: Gallery,
      query: {
        page: 1,
      },
    },
    {
      path: '/portfolio',
      name: 'portfolio',
      component: Portfolio,
    },
    {
      path: '/404',
      component: Error404,
    },
    { path: '*', redirect: '/404' },
  ],
});
